import goals from "../../../../src/components/content/goals/m10";
import * as React from 'react';
export default {
  goals,
  React
};